
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <g clip-path="url(#clip0_2874_24)"><path d="M7.54518 8.81801L7.54518 5.54053C7.55948 4.36349 8.03342 3.23868 8.86578 2.40632C9.69814 1.57396 10.8229 1.10002 12 1.08572V1.08572C13.177 1.10002 14.3019 1.57396 15.1342 2.40632C15.9666 3.23868 16.4405 4.36349 16.4548 5.54053L16.4548 8.81801"></path><path d="M16.4548 15.182L16.4548 18.4595C16.4405 19.6365 15.9666 20.7613 15.1342 21.5937C14.3019 22.426 13.177 22.9 12 22.9143V22.9143C10.8229 22.9 9.69814 22.426 8.86578 21.5937C8.03342 20.7613 7.55948 19.6365 7.54518 18.4595L7.54518 15.182"></path></g><defs><clipPath id="clip0_2874_24"><rect width="24" height="24"></rect></clipPath></defs>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiUnlock",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
